import { render, staticRenderFns } from "./BindsRadio.vue?vue&type=template&id=d9c8ca16&"
import script from "./BindsRadio.vue?vue&type=script&lang=js&"
export * from "./BindsRadio.vue?vue&type=script&lang=js&"
import style0 from "./BindsRadio.vue?vue&type=style&index=0&id=d9c8ca16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports